import { AxiosError } from 'axios'
import { z } from 'zod'

/** Corps d'erreur rédigé par l'API : seul son `message` est affichable. */
const apiErrorBodySchema = z.object({ message: z.string() })

interface ResolveAuthErrorMessageOptions {
  credentialsMessage?: string
  fallbackMessage?: string
  forbiddenMessage?: string
}

export function resolveAuthErrorMessage(
  error: Error,
  options: ResolveAuthErrorMessageOptions = {}
): string {
  const {
    credentialsMessage,
    fallbackMessage = 'Une erreur est survenue. Veuillez réessayer.',
    forbiddenMessage,
  } = options

  if (error instanceof AxiosError) {
    const status = error.response?.status
    const body = apiErrorBodySchema.safeParse(error.response?.data)
    const apiMessage = body.success ? body.data.message : undefined

    if (forbiddenMessage && status === 403) {
      return forbiddenMessage
    }

    if (credentialsMessage && (status === 400 || status === 401)) {
      return credentialsMessage
    }

    if (status && status >= 500) {
      return 'Une erreur interne est survenue. Veuillez réessayer.'
    }

    if (apiMessage === 'Internal server error') {
      return 'Une erreur interne est survenue. Veuillez réessayer.'
    }

    if (apiMessage) {
      return apiMessage
    }
  }

  return fallbackMessage
}
